import type { CssSizeUnit, } from "../../../types";
import styled from "styled-components";
import { Box, } from "../Box";



export const FloatImage = styled(Box)<{ url: string; $width?: CssSizeUnit; $height?: CssSizeUnit; $anchor?: "top-right" | "top-left" | "bottom-right" | "bottom-left" | "center"; $spacing?: CssSizeUnit; $size?: CssSizeUnit | "cover" | "contain"; }>`
	position: absolute;
	${({ url = "/logos/morpho-logo.svg", }) => `background-image: url(${url});`};
	${({ $width = "50px", }) => `width: ${$width};`};
	${({ $height = "50px", }) => `height: ${$height};`};
	${({ $anchor = "top-right", $spacing = "0px", }) => $anchor?.split("-").includes("top") && `top: ${$spacing};`}
	${({ $anchor = "top-right", $spacing = "0px", }) => $anchor?.split("-").includes("right") && `right: ${$spacing};`}
	${({ $anchor = "top-right", $spacing = "0px", }) => $anchor?.split("-").includes("bottom") && `bottom: ${$spacing};`}
	${({ $anchor = "top-right", $spacing = "0px", }) => $anchor?.split("-").includes("left") && `left: ${$spacing};`}
	${({ $size = "cover", }) => `background-size: ${$size}`};
	background-repeat: no-repeat;
	background-position: center;
	padding: 0rem;
`;
